import React from "react";
import { StickyBox } from "../../../../shared/StickyBox/StickyBox";
import { ButtonScrollTop } from "../../../../shared/ButtonScrollTop/ButtonScrollTop";
import { useReport } from "./hooks/useReport";
import { Table } from "./shared/Table";
import { Header } from "./shared/Header";

export function Shopify({ patientId }) {
  var { reports, search, order } = useReport(patientId);

  return (
    <div>
      <Header search={search} />
      <Table reports={reports} order={order} />
      <StickyBox position="left" visibleAfterOffset={300}>
        <ButtonScrollTop />
      </StickyBox>
    </div>
  );
}
